/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const ForwardArrowIcon: FC<IProps> = ({ fill = "#262626", width = 15, height = 15 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M8.275 0.586391L14.725 7.06139C14.825 7.14473 14.8957 7.24073 14.937 7.34939C14.979 7.45739 15 7.56973 15 7.68639C15 7.80306 14.979 7.91573 14.937 8.02439C14.8957 8.13239 14.825 8.22806 14.725 8.31139L8.275 14.7864C8.125 14.9197 7.95 14.9907 7.75 14.9994C7.55 15.0074 7.375 14.9364 7.225 14.7864C7.075 14.6364 6.996 14.4614 6.988 14.2614C6.97933 14.0614 7.05 13.8781 7.2 13.7114L12.5 8.43639H0.875C0.675 8.43639 0.5 8.36573 0.35 8.22439C0.2 8.08239 0.125 7.90306 0.125 7.68639C0.125 7.46973 0.2 7.29073 0.35 7.14939C0.5 7.00739 0.675 6.93639 0.875 6.93639H12.5L7.2 1.63639C7.06667 1.50306 6.996 1.33239 6.988 1.12439C6.97933 0.915727 7.05 0.736391 7.2 0.586391C7.35 0.436391 7.529 0.361391 7.737 0.361391C7.94567 0.361391 8.125 0.436391 8.275 0.586391Z" fill={fill}/>
  </svg>
);

export default ForwardArrowIcon;
